const requestCommon = {
    credentials: 'same-origin',
    cache: 'no-cache'
} as RequestInit

const jsonHeaders = {
    'Content-Type': 'application/json'
} as HeadersInit

export enum METHODS {
    GET = 'GET',
    POST = 'POST',
    DELETE = 'DELETE',
    PUT = 'PUT'
}
const PREFIX_URL_REPORT = '/services/reports-maker/api/'
const PREFIX_URL_LIVE = '/rest/'

export default async function fetchApi<T>(url: string, method = METHODS.GET, body?: string | undefined): Promise<T> {
    return await fetch(PREFIX_URL_REPORT + url, { ...requestCommon, headers: jsonHeaders, method, body }).then(
        async response => {
            // reading the stream only once.
            const finalRes = await response.json()

            if (!response.ok) {
                if(finalRes.then) {
                    finalRes.then(errorText => {
                        throw errorText
                    })
                }else {
                    throw new Error(finalRes.error)
                }
            }

            return finalRes
        }
    )
}

export async function getLiveApi<T>(url: string): Promise<T> {
    return await fetch(PREFIX_URL_LIVE + url, { ...requestCommon, headers: jsonHeaders, method: METHODS.GET }).then(
        async response => {
            // reading the stream only one time..
            const finalRes = await response.json()

            if (!response.ok) {
                finalRes.then(errorText => {
                    throw errorText
                })
            }

            return finalRes
        }
    )
}

export function objectToString(obj: { [key: string]: any }): string {
    return JSON.stringify(
        Object.entries(obj).reduce((state, [key, value]) => (!value ? state : { ...state, [key]: value }), {})
    )
}
